import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  ten: undefined, // required, minLength: 1 - Tên gói dịch vụ
  ma: undefined,
  // required - Chu kỳ gói
  chu_ky_goi: {
    loai: undefined, // required, enum(nam, quy, thang) - Loại giá trị chu kỳ gói
    gia_tri: undefined, // required - Giá trị chu kỳ gói
  },
  danh_sach_chuc_nang: [
    // optional - Danh sách chức năng
    {
      ma: undefined, // required - Mã chức năng
      ten: undefined, // required - Tên
      gia_tri: undefined, // required - Giá trị
    },
  ],
  cong_khai: false, // required - Cho biết gói dịch vụ này có phải loại công khai hay không
  thoi_diem_cap_nhat: undefined, // required - Thời điểm cập nhật cuối
  nguoi_cap_nhat_id: undefined, // required, ref: mushroom_user - Mã người cập nhật cuối
};

// validation form
model.validForm = {
  tieu_de: [ValidService.required, ValidService.checkSpaceString],
  phan_loai: [ValidService.required, ValidService.requiredChange],
  noi_dung: [ValidService.required], // required Giá trị hệ số
  hien_thi: [], // required Đã bị khóa chưa
};
model.cong_khai = [
  { label: "Công khai dịch vụ", value: "true" },
  { label: "Ẩn dịch vụ", value: "false" },
];
model.chu_ky_goi = [
  { label: "Năm", value: "nam" },
  { label: "Quý", value: "quy" },
  { label: "Tháng", value: "thang" },
];
model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_cap_nhat",
  defaultSort: ["thoi_diem_cap_nhat", "descending"],
  filters: "",
  fields:
    "id, thu_tu, ten, chu_ky_goi, danh_sach_chuc_nang, cong_khai, thoi_diem_cap_nhat",
  recordSelected: [],

  dataSearch: {
    value: {
      ten: "",
      "chu_ky_goi.loai": "",
      cong_khai: "",
    },
    valid: {
      thu_tu: [],
      ten: [],
      thoi_diem_cap_nhat: [],
    },
    operator: {
      ten: ":regex_i:",
      "chu_ky_goi.loai": "",
      cong_khai: "",
    },
  },
};

export default model;
